import * as PN from '@/utils/PermissionNames'

export default {
  namespaced: true,
  state: {},
  getters: {
    user(state, getters, rootState) {
      return rootState.auth.user
    },
    permissions(state, getters) {
      return getters.user && typeof getters.user.permissions !== 'undefined' ? getters.user.permissions : []
    },
    /**
     * Wrapper for permission check. You can override complex permission check into the function in current module getters
     * @param state
     * @param getters
     * @returns {Function}
     */
    can: (state, getters = null) => (permission, params = null) => {
      if (typeof getters[permission] === 'function') {
        return getters[permission](params)
      }
      return getters.permissions[permission] || false
    },
    /**
     * Check if user has permission to book for others
     * @param state
     * @param getters
     * @returns {boolean}
     */
    canBookForOthers: (state, getters) => {
      return !!getters.permissions[PN.DESK_EVENT_BOOK_FOR_OTHERS]
    }
  },
  actions: {},
  mutations: {}
}
